import React, { ReactElement, useEffect } from 'react';
import {
  Breadcrumbs,
  getTitle,
  homeBreadcrumb,
  PageLoader,
  setTitle,
} from 'slovlex-idsk-react-components';
import classNames from 'classnames';
import { useLocation, useParams } from 'react-router';
import {
  LegislativnyMaterialDetail,
} from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import routes from '../../../routing/routes';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import './legislativnyMaterialDetailPage.scss';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import {
  usePracovnyKrokLegislativnyMaterialContext,
} from '../../../context/PracovnyKrokLegislativnyMaterialContext';
import SuccessMessages from '../../../module/SuccessMessages';
import externalRoutes from '../../../routing/externalRoutes';
import RssLink from '../../../module/PageHeadingWithBackButton/RssLink';

const LegislativnyMaterialDetailPage = (): ReactElement => {
  const {
    materialStatus,
    materialDetail,
    reloadMaterialDetail,
  } = useLegislativnyMaterialDetail();
  const currentLocation = useLocation();
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const { loadingMaterial } = usePracovnyKrokLegislativnyMaterialContext();

  function isPredbeznaInformacia(): boolean {
    return type === 'PI';
  }

  const classes: string = classNames(
    'legislativny-material-detail-page',
    loadingMaterial && 'slovlex-idsk-hidden',
  );

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia() ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia() ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: currentLocation.pathname,
        }]}
      />
      <PageLoader loading={loadingMaterial} />
      <div className={classes}>
        <GlobalErrors />
        <SecuredPage
          requestStatus={materialStatus.responseCode}
        >
          <PageLoader loading={materialStatus.loading}>
            <>
              <SuccessMessages />
              {materialDetail && (
                <>
                  <PageHeadingWithBackButton
                    heading={materialDetail.cisloLegislativnehoMaterialu}
                    headingCaption="Legislatívny proces"
                    withBackLink
                    elementNextToHeading={(
                      <RssLink
                        to={externalRoutes.rss.legislativnyMaterial.detail.withParams(type, year, index)}
                      />
                          )}
                  />
                  <LegislativnyMaterialDetail
                    materialDetail={materialDetail}
                    reloadMaterialDetail={reloadMaterialDetail}
                  />
                </>
              )}
            </>
          </PageLoader>
        </SecuredPage>
      </div>
    </Layout>
  );
};

export default LegislativnyMaterialDetailPage;
